var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import { TabInterface } from '@/views/Users/Student/Student';
let NavigationCard = class NavigationCard extends Vue {
};
__decorate([
    Prop(),
    __metadata("design:type", typeof (_a = typeof TabInterface !== "undefined" && TabInterface) === "function" ? _a : Object)
], NavigationCard.prototype, "tab", void 0);
NavigationCard = __decorate([
    Component({
        components: {},
    })
], NavigationCard);
export default NavigationCard;
